import { TemplateConfig } from '../types';

export const feelingsThoughtsConfig: TemplateConfig = {
  id: 'feelings-thoughts',
  name: 'TA对我的想法和感觉',
  description: '了解TA对你的想法和感觉',
  cardCount: 3,
  
  fieldDefaults: {
    title: '他对我的想法和感觉',
    customerQuestion: '**在TA心里我是什么样子的、TA对我的感情是怎样的**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌'
    ]
  },
  
  disabledFields: ['customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#ff6b6b',
    backgroundColor: '#fff0f0',
    icon: '💭'
  },

  spreadLayout: {
    coordinate: 'normalized',
    cardSize: {
      widthRatio: 0.25,
      heightRatio: 0.65875,
      anchor: 'center'
    },
    positions: [
      { x: 0.2, y: 0.5 },
      { x: 0.5, y: 0.5 },
      { x: 0.8, y: 0.5 }
    ]
  }
};
